var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"text-center mt-5 mb-5"},[_vm._v("Pie Graph")]),_c('canvas',{ref:"canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }